export const trackIDs = {
    loan: {
        elementId: 'products-web-loan',
        newLoanId: 'products-web-loan__new-loan',
    },
    insurance: {
        elementId: 'products-web-insurance',
        salesId: 'products-web-insurance__buy-new',
        salesGatewayId: 'products-web-insurance__buy-new-gateway',
    },
    holdings: {
        elementId: 'products-web-holdings',
        saveMoreId: 'products-web-holdings__save-more',
    },
    totalSavings: {
        id: 'products-web-total-savings',
        saveMoreId: 'products-web-total-savings__start-saving',
    },
    linkId: 'products-web-link',
    otherLoans: 'products-web__other-loans',
    landingPage: {
        insurance: 'products-web__landing-page-insurance',
        holdings: 'products-web__landing-page-holdings',
        taskManager: 'products-web__landing-page-task-manager',
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHJhY2tJRHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi8uLi8uLi9zcmMvdXRpbHMvZ3RtL3RyYWNrSURzL3RyYWNrSURzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sQ0FBQyxNQUFNLFFBQVEsR0FBRztJQUNwQixJQUFJLEVBQUU7UUFDRixTQUFTLEVBQUUsbUJBQW1CO1FBQzlCLFNBQVMsRUFBRSw2QkFBNkI7S0FDM0M7SUFDRCxTQUFTLEVBQUU7UUFDUCxTQUFTLEVBQUUsd0JBQXdCO1FBQ25DLE9BQU8sRUFBRSxpQ0FBaUM7UUFDMUMsY0FBYyxFQUFFLHlDQUF5QztLQUM1RDtJQUNELFFBQVEsRUFBRTtRQUNOLFNBQVMsRUFBRSx1QkFBdUI7UUFDbEMsVUFBVSxFQUFFLGtDQUFrQztLQUNqRDtJQUNELFlBQVksRUFBRTtRQUNWLEVBQUUsRUFBRSw0QkFBNEI7UUFDaEMsVUFBVSxFQUFFLDBDQUEwQztLQUN6RDtJQUNELE1BQU0sRUFBRSxtQkFBbUI7SUFDM0IsVUFBVSxFQUFFLDJCQUEyQjtJQUN2QyxXQUFXLEVBQUU7UUFDVCxTQUFTLEVBQUUsc0NBQXNDO1FBQ2pELFFBQVEsRUFBRSxxQ0FBcUM7UUFDL0MsV0FBVyxFQUFFLHlDQUF5QztLQUN6RDtDQUNKLENBQUMifQ==